module.exports = __webpack_public_path__ + "img/mile1m.6a2d0985.jpg";